import { KText } from '@/ui-library/components/text';
import {
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useDisclosure,
  Box,
  Portal,
} from '@chakra-ui/react';
import { KTag } from 'ui-library/components';
import { useRef } from 'react';

const officeOthers = (offices = []) => {
  return (
    <Flex flexDir="column">
      {offices?.map((i, ind) => (
        <Flex key={ind} alignItems="center" gap=".25em">
          <KText key={i?.label} fontSize="sm" color="secondary-700">
            {i}
          </KText>
        </Flex>
      ))}
    </Flex>
  );
};

const officeInitial = (list) =>
  list.map((i, ind) => (
    <KText key={ind} fontSize="sm" color="secondary-700">
      {i}
    </KText>
  ));

const uiConfig = {
  office: {
    initial: officeInitial,
    others: officeOthers,
  },
};

export const ViewMorePopover = ({
  list = [],
  max = 1,
  renderInitial = (data) => {},
  renderOthers = (data) => {},
  moreTextStyles = {},
  popOverStyles = {},
  emptyMsg = '-',
  type = 'office',
  placement = 'bottom',
  trigger = 'click',
  parentIsOpen = true,
}) => {
  const { isOpen, onToggle, onClose, onOpen } = useDisclosure();
  const itemToRenderOnInitial = list?.slice(0, max);
  const itemsToRenderOnPopover = list?.length - max || [];
  const prevParentIsOpenRef = useRef(parentIsOpen);

  const { initial = renderInitial, others = renderOthers } =
    uiConfig[type] || {};

  // Reset child popover state when parent reopens
  if (!prevParentIsOpenRef.current && parentIsOpen) {
    if (isOpen) {
      onClose();
    }
  }
  prevParentIsOpenRef.current = parentIsOpen;

  const childIsOpen = parentIsOpen && isOpen;

  const handleOnTrigger = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onToggle();
  };

  const renderArrayList = () => {
    return (
      <Popover
        trigger={trigger}
        isOpen={childIsOpen}
        {...(trigger === 'hover' && { onOpen })}
        onClose={onClose}
        placement={placement}
        closeOnBlur={true}
      >
        <PopoverTrigger>
          <Box onClick={(e) => e.stopPropagation()}>
            <KTag
              cursor="pointer"
              fontSize="sm"
              width="max-content"
              {...moreTextStyles}
              onClick={handleOnTrigger}
              value={`+ ${itemsToRenderOnPopover}`}
              _groupHover={{
                bgColor: 'ats-secondary',
              }}
            ></KTag>
          </Box>
        </PopoverTrigger>
        <Portal appendToParentPortal={false}>
          <PopoverContent
            maxH="14em"
            overflowY="auto"
            maxW="12em"
            rootProps={{ zIndex: 9999 }}
            {...popOverStyles}
            onClick={(e) => e.stopPropagation()}
          >
            <PopoverBody>{others(list, itemsToRenderOnPopover)}</PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    );
  };

  if (list?.length === 0)
    return <KText color="secondary-500">{emptyMsg}</KText>;

  const tooltipText =
    Array.isArray(itemToRenderOnInitial) &&
    itemToRenderOnInitial.length > 0 &&
    typeof itemToRenderOnInitial[0] === 'string'
      ? itemToRenderOnInitial.join(', ')
      : null;

  return (
    <Flex gap="0.375em" alignItems="center">
      <KText
        maxW="100%"
        isTruncated
        enableTooltip={tooltipText ? true : false}
        tooltipText={tooltipText}
      >
        {initial(itemToRenderOnInitial)}
      </KText>
      {itemsToRenderOnPopover >= 1 && renderArrayList()}
    </Flex>
  );
};
